module.exports = __webpack_public_path__ + "img/home-delivery-date.d2f4d9dd.webp";